<template>
  <div>
    <div class="header">
      <div class="content">
        <img src="../../assets/logo.png" alt="" srcset="" @click="goHomePge"/>
        <!-- <div class="logo_text">达人营销</div> -->
        <ul>
          <!-- <li><a href="http://guanxing.changwankeji.com" target="_blank">首页</a></li> -->
          <li :class="{ 'active': ['/list', '/live-talent',].includes(path) }">
            <el-dropdown trigger="click" @command="tabClick">
              <a href="javascript:void(0);" class="el-dropdown-link">内容传播达人
                <i class="el-icon-arrow-down el-icon--right"></i>
              </a>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="list" :style="{color:(path === '/list'?'#FF5C00':'#4E5969')}">达人广场</el-dropdown-item>
                <!-- <el-dropdown-item command="live-talent" :style="{color:(path === '/live-talent'?'#FF5C00':'#4E5969')}">直播达人</el-dropdown-item> -->
                <el-dropdown-item v-if="scheduleAuth.canshow_square" command="hosts-square" :style="{color:(path === '/hosts-square'?'#FF5C00':'#4E5969')}">主播广场</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>

          <li :class="{'active' : ['/ai', '/ksHelper', '/orderRecommend', '/inquiryMatch', '/inquiryQuickRecommendations', '/profit-calculator', '/pgy-data-export', '/douyin-star-export'].includes(path)}">
            <el-dropdown trigger="click" @command="tabClick">
              <a href="javascript:void(0);" class="el-dropdown-link">达人推荐助手<i class="el-icon-arrow-down el-icon--right"></i></a>
              <el-dropdown-menu slot="dropdown">
                <!-- <el-dropdown-item command="inquiryMatch" :style="{color:(path === '/inquiryMatch'?'#FF5C00':'#4E5969')}">询单智能匹配</el-dropdown-item> -->
                <el-dropdown-item command="inquiryQuickRecommendations" :style="{color:(path === '/inquiryQuickRecommendations'?'#FF5C00':'#4E5969')}">询单快速推荐</el-dropdown-item>
                <el-dropdown-item command="profit-calculator" :style="{color:(path === '/profit-calculator'?'#FF5C00':'#4E5969')}">利润计算器</el-dropdown-item>
                <el-dropdown-item command="talent-fast-search" :style="{color:(path === '/talent-fast-search'?'#FF5C00':'#4E5969')}">达人快搜</el-dropdown-item>
                <el-dropdown-item command="pgy-data-export" v-if="isShowPGYPage" :style="{color:(path === '/pgy-data-export'?'#FF5C00':'#4E5969')}">蒲公英数据导出</el-dropdown-item>
                <el-dropdown-item command="douyin-star-export" v-if="isShowDyxtPage" :style="{color:(path === '/douyin-star-export'?'#FF5C00':'#4E5969')}">星图数据导出</el-dropdown-item>

                <!-- <el-dropdown-item command="orderRecommend" :style="{color:(path === '/orderRecommend'?'#FF5C00':'#4E5969')}">询单智能推荐</el-dropdown-item> -->
                <!-- <el-dropdown-item command="ai" :style="{color:(path === '/ai'?'#FF5C00':'#4E5969')}">抖音达人推荐</el-dropdown-item>
                <el-dropdown-item command="ksHelper" :style="{color:(path === '/ksHelper'?'#FF5C00':'#4E5969')}">快手达人推荐</el-dropdown-item> -->
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <!-- <li :class="path === '/same' ? 'active' : ''"><a href="javascript:void(0);" @click="tabClick('same')">找相似达人</a></li> -->
          <li :class="{'active' : ['/talent-monthly', '/not-Recommended',].includes(path)}">
            <el-dropdown trigger="click" @command="tabClick">
              <a href="javascript:void(0);" class="el-dropdown-link">达人信息集合<i class="el-icon-arrow-down el-icon--right"></i></a>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="$store.state.auth.showTalentList==1"  command="talent-monthly" :style="{color:(path === '/talent-monthly'?'#FF5C00':'#4E5969')}">达人刊例</el-dropdown-item>
                <el-dropdown-item v-if="scheduleAuth.canshow_not_rec_talent" command="tjdr" :style="{color:(path === '/profit-calculator'?'#FF5C00':'#4E5969')}">不推荐达人</el-dropdown-item>
                <el-dropdown-item v-if="scheduleAuth.canshow_rec_talent" command="qtdr" :style="{color:(path === '/profit-calculator'?'#FF5C00':'#4E5969')}">强推达人</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li :class="{'active' : ['/schedule-dashboard', '/schedule-relation-order'].includes(path)}" v-if="scheduleAuth.canshow_table || scheduleAuth.canshow_orderpqlist">
            <el-dropdown trigger="click" @command="tabClick">
              <a href="javascript:void(0);" class="el-dropdown-link">资产账号档期<i class="el-icon-arrow-down el-icon--right"></i></a>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-if="scheduleAuth.canshow_table"  command="schedule-dashboard" :style="{color:(path === '/schedule-dashboard'?'#FF5C00':'#4E5969')}">资产账号档期看板</el-dropdown-item>
                <el-dropdown-item v-if="scheduleAuth.canshow_orderpqlist" command="schedule-relation-order" :style="{color:(path === '/schedule-relation-order'?'#FF5C00':'#4E5969')}">档期与订单关联情况</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </li>
          <li v-if="auth['institutional-cooperation-policy']" :class="{'active': path == '/institutional-cooperation-policy'}"><a href="javascript:void(0);" @click="tabClick('institutional-cooperation-policy')">机构合作政策</a></li>
          <!-- <li v-if="$store.state.auth.showTalentList==1" :class="path === '/talent-monthly' ? 'active' : ''"><a href="javascript:void(0);" @click="tabClick('talent-monthly')">达人刊例</a></li> -->
          <!-- <li :class="$route.path.includes('/searchTopic') ? 'active' : ''"><a href="javascript:void(0);" @click="tabClick('searchTopic')">搜话题</a></li> -->
          <!-- <li v-if="scheduleAuth.canshow_table" :class="path === '/schedule-dashboard' ? 'active' : ''"><a href="javascript:void(0);" @click="tabClick('schedule-dashboard')">资产账号档期</a></li> -->
        </ul>
        <div class="user">
          <!-- <div class="my-favorites-wrap">
            <el-button round size="mini" @click="showFavorites = true" icon="el-icon-star-on" type="primary">已选达人（{{$store.state.favoriteTotal}}）</el-button>
          </div> -->
          <!-- <img src="../../assets/user_icon.png" alt="" /> -->
          <div class="shopping-cart" @click="tabClick('shopping-cart')">
            <img :src="require('@/assets/images/i-cart-2.png')" >
            <span v-if="$store.state.shoppingCart.count == 0">达人清单</span>
            <span v-else>已添加{{ $store.state.shoppingCart.count }}位达人</span>
          </div>
          <img src="@/assets/user.png" alt="" />
          <p class="userId">{{ user }}</p>
          <div class="exit" @click="exit">退出</div>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <favorites v-model="showFavorites"></favorites>
  </div>
</template>

<script>
// import func from 'vue-editor-bridge';
export default {
  data() {
    return {
      user: "-",
      // path: '',
      showFavorites: false,
      scheduleAuth: JSON.parse(localStorage.getItem('scheduleAuth')) || {},
      auth: {
        'institutional-cooperation-policy': false
      }
    };
  },
  components: {
    Favorites: () => import('./Favorites.vue')
  },
  watch: {
  },
  mounted() {
    this.user = localStorage.getItem('name')
    // console.log(this);
  },
  created() {
    // this.path = this.$route.path
    this.getAuth()
    // this.getFavoriteList()
    // 刷新购物车数量
    this.$store.dispatch('shoppingCart/refreshCount')

  },
  computed:{
    path(){
      return this.$route.path
    },
    isShowPGYPage(){
      const centername = localStorage.getItem('gx_centername')
      return ['短视频产品事业部', '小红书产品部', '技术中心'].includes(centername)
    },
    isShowDyxtPage(){
      const centername = localStorage.getItem('gx_centername')
      const uid = localStorage.getItem('uid')
      return (
        ['短视频产品事业部', '小红书产品部', '技术中心'].includes(centername) ||
        uid == '502' //翁林胥
      )
    },
  },
  methods: {
    goHomePge(){
      this.$router.push({path: '/list'})
    },
    exit: function() {
      this.$api.logout()
    },
    tabClick(val) {
      if(`/${val}` === this.path) return;
      let path = `/${val}`
      if(val == "tjdr"){
        path = '/not-Recommended'
        let logParams = {
          type: 112,
        }
        this.$api.setUseLog(logParams)
      }
      if(val == "qtdr"){
        path = '/not-Recommended?rec=1'
        let logParams = {
          type: 113,
        }
        this.$api.setUseLog(logParams)
      }
      if(val == "talent-fast-search"){
        let logParams = {
          type: 88,
        }
        this.$api.setUseLog(logParams)
      }else if(val === 'profit-calculator') {
        let logParams = {
          type: 110,
        }
        this.$api.setUseLog(logParams)
      }else if(val === 'talent-monthly') {
        let logParams = {
          type: 111,
        }
        this.$api.setUseLog(logParams)
      }
      // this.path = path
      // this.$router.push({path})
      this.$utils.openNewTab({path})
    },
    getFavoriteList(){
      this.$axios.get('/author-collect', {
        params: {page: 1}
      }).then(res => {
        if(res?.data?.code === 0){
          localStorage.setItem('favoriteTotal', res?.data?.data?.pagination?.total_count || 0)
          this.$store.commit('FAVORITETOTAL', res?.data?.data?.pagination?.total_count || 0)
        }
      })
    },
    async getAuth(){
      // 资产账号档期权限
      const scheduleAuth = await this.$axios.post('/api.php?m=crmzfhpq|api|databoard&a=pqtableauth')
      this.scheduleAuth = scheduleAuth || {}
      localStorage.setItem('scheduleAuth',JSON.stringify(scheduleAuth))

      // 机构合作政策权限
      this.auth['institutional-cooperation-policy'] = this.scheduleAuth.userinfo.type == 1 || localStorage.getItem('gx_centername') == '短视频产品事业部'
    },
    }
};
</script>

<style scoped lang="less">
.header {
  width: 100%;
  height: 48px;
  background: #fff;
}
.header .content {
  width: calc(100% - 100px);
  height: 48px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.header .content img{
  height: 28px;
}

.header .content .logo_text {
  font-size: 18px;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  font-weight: 500;
  color: #333333;
  line-height: 32px;
  margin-left: 15px;
  cursor: default;
}

.header .content ul {
  display: flex;
  margin-left: 50px;
  gap: 40px;
}

.header .content ul li a{
  font-size: 14px;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  font-weight: 500;
  // color: #333333;
  color: #4E5969;
  line-height: 32px;
}

.header .content ul li:hover {
  cursor: pointer;
}


.header .content ul li.active a {
  color: #FF5C00;
}

.header .content .user {
  display: flex;
  align-items: center;
  margin-left: auto;
}
.user img{
  border-radius: 50%;
}

.user .exit {
  font-size: 13px;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  font-weight: 300;
  color: #86909C;
  margin-left: 16px;
}

.user .exit:hover {
  cursor: pointer;
}

.user .userId {
  font-size: 14px;
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  font-weight: bold;
  color: #1d2129;
  margin-left: 10px;
}
.el-dropdown-menu__item:not(.is-disabled):hover{
  color: #FF5C00;
  background-color:transparent;
}
.my-favorites-wrap{
  margin-right: 10px;
  /deep/ button{
    display: flex;
    align-items: center;
    font-size: 14px ;
    padding: 0 8px;
    height: 30px;
    line-height: 30px;
  }
}

.shopping-cart {
  padding:4px 10px;
  box-sizing: border-box;
  border: 1px solid #FF5C00;
  border-radius: 20px;
  color: #ff5c00;
  font-family: "Arial Normal", Arial, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  height: 30px;
  display: flex;
  align-items: center;
  margin-right: 10px;
  cursor: pointer;
  img{
    display: block;
    margin-right: 4px;
    width: 14px;
    height: 14px !important;
  }
}
</style>